module.exports = __webpack_public_path__ + "static/home2-5cd6fda846caabcf31eeee4553fcc7ff.jpg";